(() => {
  const storageKey = 'torras_preferred_locale';
  const skipRedirectKey = 'torras_skip_locale_redirect_once';
  const isLocalPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
  const localePrefixes = {
    en: '',
    'zh-cn': isLocalPreview ? '/zh-cn' : '/zh-hans',
    'zh-tw': isLocalPreview ? '/zh-tw' : '/zh-hant',
    ms: '/ms',
  };

  const cleanFaqPath = window.location.pathname.replace(/\/pages\/faqs\.html\/?$/i, '/pages/faqs');
  if (cleanFaqPath !== window.location.pathname) {
    window.history.replaceState(
      window.history.state,
      '',
      `${cleanFaqPath}${window.location.search}${window.location.hash}`
    );
  }

  if (isLocalPreview) {
    const localAliasMatch = window.location.pathname.match(/^\/(zh-hans|zh-hant)(?=\/|$)/i);
    if (localAliasMatch) {
      const localPrefix = localAliasMatch[1].toLowerCase() === 'zh-hans' ? '/zh-cn' : '/zh-tw';
      const localPath = `${localPrefix}${window.location.pathname.slice(localAliasMatch[0].length)}`;
      window.location.replace(`${localPath}${window.location.search}${window.location.hash}`);
      return;
    }
  }

  function normalizeLocaleDestination(href) {
    let destination = String(href || '').trim();
    if (!destination) return '';

    if (/^\/\/(?:pages|products|collections|blogs|policies|search|cart|account)(?:\/|$|\?|#)/i.test(destination)) {
      destination = destination.slice(1);
    } else if (destination.startsWith('//')) {
      return destination;
    }

    try {
      const url = new URL(destination, window.location.origin);
      if (url.origin !== window.location.origin) return destination;
      url.pathname = url.pathname
        .replace(/^\/(zh-hans|zh-hant|zh-cn|zh-tw|ms)(?=[^/])/, '/$1/')
        .replace(/\/{2,}/g, '/');
      url.pathname = url.pathname.replace(/\/pages\/contact-us(?:-1|\.html)\/?$/i, '/pages/contact-us');
      url.pathname = url.pathname.replace(
        /^((?:\/(?:zh-hans|zh-hant|zh-cn|zh-tw|ms))?\/pages\/faqs)(?:\.html)?\/?$/i,
        '$1'
      );
      if (isLocalPreview) {
        url.pathname = url.pathname
          .replace(/^\/zh-hans(?=\/|$)/i, '/zh-cn')
          .replace(/^\/zh-hant(?=\/|$)/i, '/zh-tw');
      }
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return destination;
    }
  }

  window.torrasNormalizeLocaleDestination = normalizeLocaleDestination;

  // Production aliases are valid on Shopify, while CLI previews use ISO-code roots.
  // Only preview links are rewritten; the live storefront keeps its native routes.
  function rewritePreviewLanguageLinks() {
    if (!isLocalPreview) return;
    const canonical = document.querySelector('link[rel="canonical"]');
    const storefrontOrigin = canonical ? new URL(canonical.href, window.location.origin).origin : window.location.origin;
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== storefrontOrigin && url.origin !== window.location.origin) return;
      const destination = normalizeLocaleDestination(`${url.pathname}${url.search}${url.hash}`);
      link.href = new URL(destination, window.location.origin).href;
    });
  }

  rewritePreviewLanguageLinks();

  const pageAliasSelector = 'a[href*="pages/contact-us" i], a[href*="pages/faqs" i]';
  const localizationLinkSelector = 'localization-form a[data-href]';
  const aliasLinkSelector = `${pageAliasSelector}, ${localizationLinkSelector}`;

  function rewriteAliasLink(link) {
    if (link.matches(localizationLinkSelector)) {
      const href = link.dataset.href;
      const destination = normalizeLocaleDestination(href);
      if (destination && destination !== href) link.dataset.href = destination;
      return;
    }

    const href = link.getAttribute('href');
    if (!href || !/(?:^|\/)pages\/(?:contact-us(?:-1)?|faqs)(?:\.html)?(?:[?#]|$)/i.test(href)) return;
    const destination = normalizeLocaleDestination(href);
    if (destination && destination !== href) link.setAttribute('href', destination);
  }

  function rewriteCachedPageAliasLinks(root = document) {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(aliasLinkSelector)) rewriteAliasLink(root);
    root.querySelectorAll?.(aliasLinkSelector).forEach(rewriteAliasLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => rewriteCachedPageAliasLinks(), { once: true });
  } else {
    rewriteCachedPageAliasLinks();
  }

  const pendingAliasRoots = new Set();
  let aliasRewriteScheduled = false;

  function queueAliasRewrite(root) {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (!root.matches(aliasLinkSelector) && !root.querySelector(aliasLinkSelector)) return;

    for (const pendingRoot of pendingAliasRoots) {
      if (pendingRoot.contains(root)) return;
      if (root.contains(pendingRoot)) pendingAliasRoots.delete(pendingRoot);
    }

    pendingAliasRoots.add(root);
    if (aliasRewriteScheduled) return;

    aliasRewriteScheduled = true;
    requestAnimationFrame(() => {
      aliasRewriteScheduled = false;
      const roots = Array.from(pendingAliasRoots);
      pendingAliasRoots.clear();
      roots.forEach(rewriteCachedPageAliasLinks);
    });
  }

  const pageAliasObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        queueAliasRewrite(mutation.target);
        continue;
      }

      mutation.addedNodes.forEach(queueAliasRewrite);
    }
  });
  pageAliasObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['href', 'data-href'],
    childList: true,
    subtree: true,
  });

  function readPreferredLocale() {
    try {
      return window.localStorage.getItem(storageKey)?.toLowerCase() || '';
    } catch (error) {
      return '';
    }
  }

  function savePreferredLocale(locale) {
    try {
      window.localStorage.setItem(storageKey, locale);
    } catch (error) {
      // Storage can be unavailable in private browsing or restricted WebViews.
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[data-value][data-href]');
      if (!link || !link.closest('localization-form')) return;
      const locale = link.dataset.value?.toLowerCase();
      if (!locale || !Object.hasOwn(localePrefixes, locale)) return;
      savePreferredLocale(locale);
      const destination = normalizeLocaleDestination(link.dataset.href);
      if (!destination) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(destination);
    },
    true
  );

  try {
    if (window.sessionStorage.getItem(skipRedirectKey) === 'true') {
      window.sessionStorage.removeItem(skipRedirectKey);
      return;
    }
  } catch (error) {
    // Session storage can be unavailable in restricted WebViews.
  }

  const preferredLocale = readPreferredLocale();
  const currentLocale = document.documentElement.lang.toLowerCase();
  if (!preferredLocale || !Object.hasOwn(localePrefixes, preferredLocale) || currentLocale !== 'en') return;
  if (preferredLocale === 'en') return;

  const basePath = window.location.pathname.replace(/^\/(?:zh-hans|zh-hant|zh-cn|zh-tw|ms)(?=\/|$)/, '') || '/';
  const targetPath = normalizeLocaleDestination(
    `${localePrefixes[preferredLocale]}${basePath === '/' ? '' : basePath}` || '/'
  );
  window.location.replace(`${targetPath}${window.location.search}${window.location.hash}`);
})();
